/**
 * Error logging
 *
 * Used to log errors to the console.
 */

/**
 * Set up error handling. Currently a no-op since Sentry has been removed.
 */
export const setup = () => {
  // No external error logging service configured
};

/**
 * Set user ID for the logger.
 * Currently a no-op since external logging has been removed.
 *
 * @param {String} userId ID of current user
 */
export const setUserId = _userId => {
  // No-op: external logging service removed
};

/**
 * Clears the user ID.
 * Currently a no-op since external logging has been removed.
 */
export const clearUserId = () => {
  // No-op: external logging service removed
};

const printAPIErrorsAsConsoleTable = apiErrors => {
  if (apiErrors != null && apiErrors.length > 0 && typeof console.table === 'function') {
    console.log('Errors returned by Marketplace API call:');
    console.table(apiErrors.map(err => ({ status: err.status, code: err.code, ...err.meta })));
  }
};

const responseAPIErrors = error => {
  return error && error.data && error.data.errors ? error.data.errors : [];
};

const responseApiErrorInfo = err =>
  responseAPIErrors(err).map(e => ({
    status: e.status,
    code: e.code,
    meta: e.meta,
  }));

/**
 * Logs an exception to the console.
 *
 * @param {Error} e Error that occurred
 * @param {String} code Error code
 * @param {Object} data Additional data for debugging
 */
export const error = (e, code, data) => {
  const apiErrors = responseApiErrorInfo(e);
  console.error(e);
  console.error('Error code:', code, 'data:', data);
  printAPIErrorsAsConsoleTable(apiErrors);
};
